// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `* {
  font-family: Roboto;
}

.heroCss_heroMainRow {
  padding-top: 3vw;
}
@media (max-width: 576px) {
  .heroCss_heroMainRow {
    padding-top: 15vw;
  }
}
@media (max-width: 576px) {
  .heroCss_weEmpowerMainRow {
    padding-top: 16vw;
  }
}
.heroCss_socialMediaImg_desktop {
  display: flexbox;
  position: absolute;
  align-items: center;
  top: 40%;
  right: 0;
}
@media (max-width: 1400px) {
  .heroCss_socialMediaImg_desktop {
    right: 6vw;
  }
}
@media (max-width: 576px) {
  .heroCss_socialMediaImg_desktop {
    display: none;
  }
}
@media (min-width: 576px) {
  .heroCss_socialMediaImg_mobileView {
    display: none;
  }
}
.heroCss_backgroundImgDiv {
  background-size: cover !important;
  height: 30.5vw;
  width: 100%;
  position: relative;
}
@media (min-width: 1680px) {
  .heroCss_backgroundImgDiv {
    height: 24.5vw;
    width: 100%;
    position: relative;
  }
}
@media (max-width: 1200px) {
  .heroCss_backgroundImgDiv {
    height: auto;
  }
}
@media (max-width: 321px) {
  .heroCss_backgroundImgDiv {
    height: 100vw;
  }
}
.heroCss_text {
  font-size: 1.2vw;
  font-style: normal;
  font-weight: 400;
  line-height: 150%;
  color: #ffffff;
  padding-left: 6vw;
  padding-right: 6vw;
}
@media (max-width: 1024px) {
  .heroCss_text {
    font-size: 2vw;
  }
}
@media (max-width: 576px) {
  .heroCss_text {
    font-size: 4vw;
    line-height: 150%;
  }
}
.heroCss_pageIntroText {
  padding-left: 6vw;
  padding-right: 6vw;
}
.heroCss_pageIntroText h1 {
  font-size: 2.6vw;
  font-style: normal;
  font-weight: 300;
  line-height: 150%;
  color: #ffffff;
  margin-bottom: 4vh;
}
@media (max-width: 1024px) {
  .heroCss_pageIntroText h1 {
    font-size: 3.5vw;
  }
}
@media (max-width: 576px) {
  .heroCss_pageIntroText h1 {
    font-size: 6vw;
    line-height: 150%;
  }
}
.heroCss_pageIntroText span {
  font-size: 1.57vw;
  font-style: normal;
  font-weight: 300;
  line-height: 150%;
  color: #ffffff;
}
@media (max-width: 1024px) {
  .heroCss_pageIntroText span {
    font-size: 1rem;
    line-height: 150%;
  }
}
.heroCss_pageIntroTextPara {
  line-height: 150% !important;
}
.heroCss_dividerDiv {
  padding-left: 6vw;
  padding-right: 6vw;
  width: 100vw;
}
.heroCss_dividerIntro {
  background-color: #fff;
  height: 1px;
  margin-top: 2vw;
  margin-bottom: 3vw;
}
.heroCss_socialMediaLogo {
  padding-left: 6vw;
  padding-right: 4vw;
  width: 100%;
}
@media (min-width: 1400px) {
  .heroCss_socialMediaLogo_linkedin {
    height: 6vh !important;
    width: 9vw !important;
  }
}`, "",{"version":3,"sources":["webpack://./src/Components/HeroIndustries/heroIndustries.scss"],"names":[],"mappings":"AAAA;EACE,mBAAA;AACF;;AAEE;EACE,gBAAA;AACJ;AAAI;EAFF;IAGI,iBAAA;EAGJ;AACF;AAAI;EADF;IAEI,iBAAA;EAGJ;AACF;AADE;EACE,gBAAA;EACA,kBAAA;EACA,mBAAA;EACA,QAAA;EACA,QAAA;AAGJ;AAFI;EANF;IAOI,UAAA;EAKJ;AACF;AAJI;EATF;IAUI,aAAA;EAOJ;AACF;AALE;EACE;IACE,aAAA;EAOJ;AACF;AAJE;EACE,iCAAA;EACA,cAAA;EACA,WAAA;EACA,kBAAA;AAMJ;AAJI;EANF;IAOI,cAAA;IACA,WAAA;IACA,kBAAA;EAOJ;AACF;AANI;EAXF;IAYI,YAAA;EASJ;AACF;AARI;EAdF;IAeI,aAAA;EAWJ;AACF;AARE;EACE,gBAAA;EACA,kBAAA;EACA,gBAAA;EACA,iBAAA;EACA,cAAA;EACA,iBAAA;EACA,kBAAA;AAUJ;AARI;EATF;IAUI,cAAA;EAWJ;AACF;AAVI;EAZF;IAaI,cAAA;IACA,iBAAA;EAaJ;AACF;AAXE;EACE,iBAAA;EACA,kBAAA;AAaJ;AAXE;EACE,gBAAA;EACA,kBAAA;EACA,gBAAA;EACA,iBAAA;EAEA,cAAA;EACA,kBAAA;AAYJ;AAXI;EARF;IASI,gBAAA;EAcJ;AACF;AAbI;EAXF;IAYI,cAAA;IACA,iBAAA;EAgBJ;AACF;AAdE;EACE,iBAAA;EACA,kBAAA;EACA,gBAAA;EACA,iBAAA;EACA,cAAA;AAgBJ;AAfI;EANF;IAOI,eAAA;IACA,iBAAA;EAkBJ;AACF;AAfE;EACE,4BAAA;AAiBJ;AAfE;EACE,iBAAA;EACA,kBAAA;EACA,YAAA;AAiBJ;AAfE;EACE,sBAAA;EACA,WAAA;EACA,eAAA;EACA,kBAAA;AAiBJ;AAfE;EACE,iBAAA;EACA,kBAAA;EACA,WAAA;AAiBJ;AAdI;EADF;IAEI,sBAAA;IACA,qBAAA;EAiBJ;AACF","sourcesContent":["* {\n  font-family: Roboto;\n}\n.heroCss {\n  &_heroMainRow {\n    padding-top: 3vw;\n    @media (max-width: 576px) {\n      padding-top: 15vw;\n    }\n  }\n  &_weEmpowerMainRow {\n    @media (max-width: 576px) {\n      padding-top: 16vw;\n    }\n  }\n  &_socialMediaImg_desktop {\n    display: flexbox;\n    position: absolute;\n    align-items: center;\n    top: 40%;\n    right: 0;\n    @media (max-width: 1400px) {\n      right: 6vw;\n    }\n    @media (max-width: 576px) {\n      display: none;\n    }\n  }\n  @media (min-width: 576px) {\n    &_socialMediaImg_mobileView {\n      display: none;\n    }\n  }\n\n  &_backgroundImgDiv {\n    background-size: cover !important;\n    height: 30.5vw;\n    width: 100%;\n    position: relative;\n\n    @media (min-width: 1680px) {\n      height: 24.5vw;\n      width: 100%;\n      position: relative;\n    }\n    @media (max-width: 1200px) {\n      height: auto;\n    }\n    @media (max-width: 321px) {\n      height: 100vw;\n    }\n  }\n\n  &_text {\n    font-size: 1.2vw;\n    font-style: normal;\n    font-weight: 400;\n    line-height: 150%;\n    color: #ffffff;\n    padding-left: 6vw;\n    padding-right: 6vw;\n\n    @media (max-width: 1024px) {\n      font-size: 2vw;\n    }\n    @media (max-width: 576px) {\n      font-size: 4vw;\n      line-height: 150%;\n    }\n  }\n  &_pageIntroText {\n    padding-left: 6vw;\n    padding-right: 6vw;\n  }\n  &_pageIntroText h1 {\n    font-size: 2.6vw;\n    font-style: normal;\n    font-weight: 300;\n    line-height: 150%;\n\n    color: #ffffff;\n    margin-bottom: 4vh;\n    @media (max-width: 1024px) {\n      font-size: 3.5vw;\n    }\n    @media (max-width: 576px) {\n      font-size: 6vw;\n      line-height: 150%;\n    }\n  }\n  &_pageIntroText span {\n    font-size: 1.57vw;\n    font-style: normal;\n    font-weight: 300;\n    line-height: 150%;\n    color: #ffffff;\n    @media (max-width: 1024px) {\n      font-size: 1rem;\n      line-height: 150%;\n    }\n  }\n\n  &_pageIntroTextPara {\n    line-height: 150% !important;\n  }\n  &_dividerDiv {\n    padding-left: 6vw;\n    padding-right: 6vw;\n    width: 100vw;\n  }\n  &_dividerIntro {\n    background-color: #fff;\n    height: 1px;\n    margin-top: 2vw;\n    margin-bottom: 3vw;\n  }\n  &_socialMediaLogo {\n    padding-left: 6vw;\n    padding-right: 4vw;\n    width: 100%;\n  }\n  &_socialMediaLogo_linkedin {\n    @media (min-width: 1400px) {\n      height: 6vh !important;\n      width: 9vw !important;\n    }\n  }\n}\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
